// extracted by mini-css-extract-plugin
module.exports = {"root":"css_root__3zVZv","inner":"css_inner__v0Q87"};